// src/components/ApprovalChain.tsx
import React from 'react';

interface ApprovalChainProps {
  assignees: Array<{
    id: string;
    user_id: string;
    role_in_task: string;
    progress_percent: number;
    user_name?: string;
    user_role?: string;
  }>;
}

export function ApprovalChain({ assignees }: ApprovalChainProps) {
  const owners = assignees.filter(a => a.role_in_task === 'OWNER');
  
  if (owners.length === 0) return null;
  
  return (
    <div className="bg-white rounded-xl shadow-md p-5 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Approval Chain</h3>
        <span className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">{owners.length}</span>
      </div>
      
      <div className="flex flex-wrap gap-4">
        {owners.map((owner, idx) => (
          <div key={owner.id} className="flex-1 min-w-[200px] relative">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                {owner.user_name?.charAt(0).toUpperCase() || 'U'}
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm">{owner.user_name || owner.user_id.slice(0, 8)}</div>
                <div className="text-xs text-gray-500">{owner.user_role || 'Employee'}</div>
              </div>
            </div>
            <div className="text-sm">
              {owner.progress_percent > 0 ? (
                <span className="text-green-600 flex items-center gap-1">
                  <span>✓</span> Approved
                </span>
              ) : (
                <span className="text-yellow-600 flex items-center gap-1">
                  <span>⏳</span> Pending Approval
                </span>
              )}
            </div>
            {idx < owners.length - 1 && (
              <div className="hidden md:block absolute -right-6 top-1/2 transform -translate-y-1/2">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}